module.exports = __webpack_public_path__ + "img/carrousel-mov-digi-3.ca665f7d.png";